import { PrintTemplatesPage } from "../../features/print-templates/print-templates-page";

export default function PrintTemplatesRoute() {
  return <PrintTemplatesPage />;
}
